import { render, staticRenderFns } from "./SafeChatText.vue?vue&type=template&id=794ffc9d&scoped=true"
import script from "./SafeChatText.vue?vue&type=script&lang=js"
export * from "./SafeChatText.vue?vue&type=script&lang=js"
import style0 from "./SafeChatText.vue?vue&type=style&index=0&id=794ffc9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794ffc9d",
  null
  
)

export default component.exports